const a = "_authorCard_1v12p_2", t = "_avatar_1v12p_15", o = "_authorInfo_1v12p_24", r = "_authorNameMeta_1v12p_34", _ = "_authorName_1v12p_34", e = "_authorMeta_1v12p_56", h = "_companyLink_1v12p_70", n = "_authorWithLabel_1v12p_95", u = "_createdByLabel_1v12p_102", c = {
  authorCard: a,
  avatar: t,
  authorInfo: o,
  authorNameMeta: r,
  authorName: _,
  authorMeta: e,
  companyLink: h,
  authorWithLabel: n,
  createdByLabel: u
};
export {
  c as s
};
//# sourceMappingURL=Author.module-DO0Qr1K7.mjs.map
